/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';
import classNames from 'classnames';

import BaseComponent from '../../../panther/components/base/BaseComponent';
import Button from '../../../panther/components/atoms/Button/Button.js';

import MicrositeModal from '../MicrositeModal/MicrositeModal';

import ActionCreator from '../../../action/ActionCreator';

import styles from './MicrositePanel.css';

class MicrositePanel extends BaseComponent {
    constructor() {
        super();
        this.state = {
            showModal: false
        }
    }

    componentWillReceiveProps(props){
        this.setState({
            showModal: props.showModal
        })
    }

    closeModal() {
        this.setState({ showModal: false });
        ActionCreator.showModal({
            modal: this.props.id,
            show: false
        });
    }

    openModal() {
        this.setState({ showModal: true });
        ActionCreator.showModal({
            modal: this.props.id,
            show: true
        });
    }

    goToLink(target) {
        ActionCreator.viewChange(target);
    }

    goToWeb(target) {
        window.location = target;
    }


    render() {
        let classes = classNames(
            'microsite-panel', {
                'highlighted': this.props.panelHighlighted,
                'without-header': this.props.withoutHeader,
                'has-footer': this.props.modal || this.props.links
            },
            this.props.className
        );

        let head = null;
        if (!this.props.withoutHeader){
            head = this.renderHeader();
        }

        let buttons = [];
        let modal = null;

        if (this.props.modal){
            buttons.push(this.renderOpenModalButton());
            modal = this.renderModal();
        } else if (this.props.links) {
            this.props.links.forEach(link => {
                if (link.type === "internal") {
                    buttons.push(this.renderInternalLinkButton(link));
                } else if (link.type === "external") {
                    buttons.push(this.renderExternalLinkButton(link));
                }
            });
        }

        return (
            <Panel className={classes}>
                {head ? head : null}
                <div className="panel-body">
                    <h3>{this.props.title}</h3>
                    <p>{this.props.text}</p>
                    {modal}
                </div>
                {buttons.length ? (<div className="panel-footer">{buttons}
                </div>) : null}
            </Panel>
        );
    }

    renderHeader(){
        return (
            <div className="panel-heading">
                <img className="panel-title-img" alt={this.props.title} src={require("../../../resources/img/panels/" + this.props.image)}/>
            </div>
        )
    }

    renderModal(){
        return (
            <MicrositeModal
                data={this.props.modal}
                open={this.state.showModal}
                onClose={this.closeModal.bind(this)}
                title={this.props.title}
            />
        );
    }

    renderOpenModalButton(){
        let buttonClasses = 'w12';
        if (this.props.panelHighlighted){
            buttonClasses = 'primary w12';
        }

        return (
            <Button
                alignCenter
                className={buttonClasses}
                lowercase
                onClick={this.openModal.bind(this)}
            >
                Read more
            </Button>
        );
    }

    renderInternalLinkButton(data){
        let buttonClasses = 'w10';

        return (
            <Button
                key={data.text}
                alignCenter
                className={buttonClasses}
                lowercase
                onClick={this.goToLink.bind(this, data.target)}
            >
                {data.text}
            </Button>
        );
    }

    renderExternalLinkButton(data){
        let buttonClasses = 'w10';

        return (
            <Button
                key={data.text}
                primary
                alignCenter
                className={buttonClasses}
                lowercase
                onClick={this.goToWeb.bind(this, data.target)}
            >
                {data.text}
            </Button>
        );
    }
}

MicrositePanel.propTypes = {
    id: PropTypes.string,
    image: PropTypes.string,
    links: PropTypes.array,
    modal: PropTypes.object,
    showModal: PropTypes.bool,
    panelHighlighted: PropTypes.bool,
    title: PropTypes.string,
    text: PropTypes.string,
    withoutHeader: PropTypes.bool
};

export default MicrositePanel;